export default __webpack_public_path__ + "static/media/et.061591dd.svg";